import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    actionDates: [],
    allActionDates: [],
    filters: {
      order_by: 'name',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async addActionDate({ commit }, { payload }) {
      const company = await this.$axios.post(`${baseURLv1}/permit/action_date/`, payload);
      commit('add', ['actionDates', company.data.data]);
    },

    async editActionDate({ commit }, { actionDate, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/permit/action_date/${id}/`, actionDate);

      commit('update', ['actionDates', { id, payload: response.data.data }]);
    },

    async getActionDateDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/action_date/${id}/`);

      return response.data.data;
    },

    async deleteActionDate({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/permit/action_date/${id}/`);

      commit('remove', ['actionDates', id]);
      return response.data.data;
    },

    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/permit/action_date/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['actionDates', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
    async loadAllActionDates({ _, commit }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/action_date/`, {
        params: {
          page_size: 1000,
        },
      });

      commit('set', ['allActionDates', response.data.data]);
    },
  },
  getters: {
    selectOptions: (state) =>
      state.allActionDates
        .map((u) => ({ name: u.name, id: u.id }))
        .sort((a, b) => a.name.localeCompare(b.name)),
  },
};
